var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5029 21.0029L7.9954 21.0012L7.9965 19.9835L17.512 19.9899C17.6447 19.99 17.772 19.9374 17.8658 19.8436C17.9597 19.7498 18.0124 19.6226 18.0124 19.4899V4.99084L5.99811 4.98938V21.006H5.00293V4.99316H4V3.99316H8V2.99609H16V3.99316H20V4.99316H19.0039V19.5029C19.004 19.9007 18.8461 20.2822 18.5649 20.5636C18.2836 20.8449 17.9022 21.0029 17.5044 21.0029H17.5029ZM16.0107 6.99274H15.0107V18.0137H16.0107V6.99274ZM10.0411 6.99857H11.0411V18.0196H10.0411V6.99857ZM12.9922 6.99857H13.9922V18.0196H12.9922V6.99857ZM7.99805 6.99656H8.99804V17.9936H7.99805V6.99656Z",
    fill: "#F34041"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.05fc0b27daf1771082be669ea95256bdb6c6ccb56163e3cfed549ef3a042cd58.svg";
export { ForwardRef as ReactComponent };